import Stack from '@mui/material/Stack'
import DateTimePickerField from '@shared/forms/DateTimePickerField'
import theme from '@globals/themes/defaultTheme'
import { T } from '@transifex/react'
import { useFormContext } from 'react-hook-form'
import { RecognitionFormData } from '@tenant/recognition/RecognitionModal/sendRecognitionView/useSendRecognitionForm'

const MobileRecognitionScheduleView = () => {
  const { control } = useFormContext<RecognitionFormData>()

  return (
    <Stack>
      <DateTimePickerField
        control={control}
        label={<T _str="Send date" />}
        labelStyle={{ mt: 0 }}
        name="scheduledAt"
        required={false}
        disablePast
        popperZIndex={theme.zIndex.modal + 2}
        timeSteps={{
          hours: 1,
          minutes: 15,
        }}
      />
    </Stack>
  )
}

export default MobileRecognitionScheduleView
